import React, { useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth';
import { paths } from '.';
import LoadingSpinner from '../components/loading-spinner';
import { TeamIdContext } from '../team-id-context';
import { DealIdContext } from '../deal-id-context';

interface PrivateRouteProps {
  children: React.ReactElement;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const [{ authLoading, queryLoading, loggedIn, user }] = useAuth() as any;
  const { teamId, dealId } = useParams();
  const navigate = useNavigate();

  const currentPath = useLocation().pathname;

  // Redirect to login if not authenticated
  useEffect(() => {
    if (!loggedIn && !authLoading && !(queryLoading && user == null)) {
      navigate(paths.auth.login, { state: { returnTo: currentPath } });
    }
  }, [loggedIn, authLoading, queryLoading, user, navigate, currentPath]);

  // Redirect if teamId in URL doesn't match any of the user's teams
  const userTeamsLoaded = loggedIn && user?.allTeams !== undefined;
  const isTeamValid = !teamId || !userTeamsLoaded || user.allTeams.some((t: { id: string }) => t.id === teamId);

  useEffect(() => {
    if (userTeamsLoaded && teamId && !user.allTeams.some((t: { id: string }) => t.id === teamId)) {
      navigate('/teams', { replace: true });
    }
  }, [userTeamsLoaded, teamId, user, navigate]);

  if (!loggedIn) {
    if (authLoading || (queryLoading && user == null)) {
      return (
        <div>
          <LoadingSpinner />
        </div>
      );
    }

    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  // Show spinner while redirecting to /teams for invalid teamId
  if (!isTeamValid) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <TeamIdContext.Provider value={teamId}>
      <DealIdContext.Provider value={dealId}>{children}</DealIdContext.Provider>
    </TeamIdContext.Provider>
  );
};

export default PrivateRoute;
